import { createFileRoute } from '@tanstack/react-router';

import { useBesluitId } from '@/api/queries/besluit';
import { useBesluitTypeId } from '@/api/queries/besluitType';
import { Dictum } from '@/components/Dictum/Dictum';

import { HTMLContent } from '../-components/HTMLContent';

/**
 * Route
 */
export const Route = createFileRoute(
  '/$bedrijfLineageId/viewer/besluit/$besluitId/_layout/besluittekst'
)({
  loader: async ({ params, context: { queryClient } }) => {
    await queryClient.ensureQueryData(
      useBesluitId.getOptions(params.besluitId)
    );
  },
  component: BesluittekstComponent,
});

/**
 * Route component
 */
function BesluittekstComponent() {
  const { besluitId } = Route.useParams();

  const besluit = useBesluitId(besluitId, {
    // After a besluit is published, it will never change again.
    staleTime: Infinity,
  });

  const besluitType = useBesluitTypeId(besluit.data?.Type ?? '', {
    enabled: !!besluit.data?.Type,
  });

  if (!besluit.data) return null;

  return (
    <>
      <HTMLContent
        besluit={besluit.data}
        title="Besluittekst"
        content={besluit.data.Besluit_Tekst}
      />

      {besluitType.data && !besluitType.data.Wijziging_zonder_besluit ? (
        <Dictum besluitId={besluitId} className="mt-8 pl-6" />
      ) : null}
    </>
  );
}
